export default __webpack_public_path__ + "static/media/keyvisual-coburg-lichtenfels.4aa61494.jpg";